
import { defineComponent, PropType } from "@vue/runtime-core";
export default defineComponent({
	name: "GamificationBadge",
	props: {},
	methods: {},
	computed: {},
});
